<template>
  <div class="p-4">
    <div class="loader-overlay" v-if="isDataFetch">
      <b-spinner
        style="width: 3rem; height: 3rem"
        type="grow"
        class="text-white"
      ></b-spinner>
    </div>

    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-6 text-left">
            <h4>Referral Partners</h4>
          </div>
          <div class="col-6 text-right">
            <appModalReferralPartnerNew></appModalReferralPartnerNew>
          </div>
        </div>
      </div>

      <div class="card-body">
        <div class="search-row mb-3">
          <div class="form-group search-box item mb-0">
            <label for="paginate" class="mb-0">Search</label>
            <input
              v-model="q"
              type="search"
              class="form-control"
              placeholder="Search ..."
              @keyup.enter="fnSearch()"
            />
          </div>

          <div class="status-box item">
            <label for="paginate" class="mb-0">Status</label>
            <select
              v-model="selectedStatus"
              class="form-control sits_select"
              @change="fnSearch()"
            >
              <option value="">All Status</option>
              <option value="0">In-active</option>
              <option value="1">Active</option>
            </select>
          </div>
          <div class="item">
            <button class="btn btn-sm btn-primary mt-4" @click="fnSearch()">
              Search
            </button>
          </div>
          <div class="item">
            <button class="btn btn-sm btn-primary mt-4" @click="fnClear()">
              Clear
            </button>
          </div>
        </div>
        <div class="table-responsive table-sm">
          <table
            class="
              v-datatable-light
              table table-bordered table-hover table-striped table-center
            "
          >
            <thead>
              <tr>
                <th class="header-item"></th>

                <th class="header-item">
                  <a href="#" @click.prevent="fnChangeSort('id')">Id</a>
                  <span v-if="sort_direction == 'desc' && sort_field == 'id'"
                    >&uarr;</span
                  >
                  <span v-if="sort_direction == 'asc' && sort_field == 'id'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item">
                  <a href="#" @click.prevent="fnChangeSort('name')">Name</a>
                  <span v-if="sort_direction == 'desc' && sort_field == 'name'"
                    >&uarr;</span
                  >
                  <span v-if="sort_direction == 'asc' && sort_field == 'name'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item">Parent Partner</th>
                <th class="header-item">Interest Rate</th>
                <th class="header-item">Package Mgt Fee</th>
                <th class="header-item">Brokerage</th>
                <th class="header-item">Lease Co Fee</th>
                <th class="header-item">VSA Fee</th>
                <th class="header-item">Stamp Duty</th>
                <th class="header-item">Registration</th>
                <th class="header-item">Reporting Commission</th>
                <th class="header-item v-th-center">
                  <a href="#" @click.prevent="fnChangeSort('status')">Status</a>
                  <span
                    v-if="sort_direction == 'desc' && sort_field == 'status'"
                    >&uarr;</span
                  >
                  <span v-if="sort_direction == 'asc' && sort_field == 'status'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item v-th-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              <template
                v-for="(row, index) in getReferralPartnerPaginateData.data"
              >
                <tr :key="(row, index)">
                  <td
                    @click="toggle(index)"
                    :class="{ opened: opened.includes(index) }"
                  >
                    <span class="text-info pl-2"
                      ><i class="fas fa-outdent"></i
                    ></span>
                  </td>
                  <td>{{ row.id }}</td>
                  <td>{{ row.name }}</td>
                  <td>
                    <span v-if="row.partner_type == 's'">{{
                      row.parent_partner_name
                    }}</span>
                  </td>
                  <td class="v-th-right">
                    {{ row.interest_rate }}
                  </td>
                  <td class="v-th-right">{{ row.package_mgt_fee }}</td>
                  <td class="v-th-right">
                    {{ row.brokerage }}
                  </td>
                  <td class="v-th-right">
                    {{ row.lease_co_fee }}
                  </td>
                  <td class="v-th-right">
                    {{ row.vsa_fee }}
                  </td>
                  <td class="v-th-right">
                    {{ row.stamp_duty }}
                  </td>
                  <td class="v-th-right">
                    {{ row.registration }}
                  </td>
                  <td class="v-th-right">
                    {{ row.reporting_commission }}
                  </td>
                  <td class="v-td-center">
                    <div v-if="row.status == 0">
                      <span class="badge bdg-draft">In-active</span>
                    </div>
                    <div v-if="row.status == 1">
                      <span class="badge bdg-new">Active</span>
                    </div>
                  </td>
                  <td class="v-td-center">
                    <div class="d-flex">
                      <appModalReferralPartnerEdit
                        :propsData="row"
                      ></appModalReferralPartnerEdit>
                    </div>
                  </td>
                </tr>

                <!-- Expandable section -->
                <tr v-if="opened.includes(index)">
                  <td colspan="14">
                    <div class="row mr-2 ml-2">
                      <div class="col-lg-4 col-md-4 col-12">
                        <dl class="row">
                          <dt class="col-sm-5">Domain name</dt>
                          <dd class="col-sm-7 mb-0">{{ row.domain_name }}</dd>
                          <dt class="col-sm-5">Web url</dt>
                          <dd class="col-sm-7 mb-0">{{ row.web_url }}</dd>
                          <dt class="col-sm-5">Primary color</dt>
                          <dd class="col-sm-7 mb-0">{{ row.primary_color }}</dd>
                          <dt class="col-sm-5">Secondary color</dt>
                          <dd class="col-sm-7 mb-0">
                            {{ row.secondary_color }}
                          </dd>
                          <dt class="col-sm-5">Logo url</dt>
                          <dd class="col-sm-7 mb-0">
                            <span
                              v-if="
                                row.logo_url &&
                                row.logo_url != 'null' &&
                                row.logo_url != null
                              "
                            >
                              <a :href="row.logo_url" target="_blank"
                                ><img :src="row.logo_url" style="width: 200px"
                              /></a>
                            </span>
                            <span v-else>
                              <i class="las la-frown fs-1400"></i>
                            </span>
                          </dd>
                        </dl>
                      </div>
                      <div class="col-lg-4 col-md-4 col-12">
                        <dl class="row">
                          <dt class="col-sm-5">BSB</dt>
                          <dd class="col-sm-7 mb-0">{{ row.bsb }}</dd>
                          <dt class="col-sm-5">Account number</dt>
                          <dd class="col-sm-7 mb-0">
                            {{ row.account_number }}
                          </dd>
                          <dt class="col-sm-5">Account name</dt>
                          <dd class="col-sm-7 mb-0">{{ row.account_name }}</dd>
                          <dt class="col-sm-5">Account email</dt>
                          <dd class="col-sm-7 mb-0">{{ row.account_email }}</dd>
                          <dt class="col-sm-5">Account secondary email</dt>
                          <dd class="col-sm-7 mb-0">
                            {{ row.account_second_email }}
                          </dd>
                          <dt class="col-sm-5">ABN</dt>
                          <dd class="col-sm-7 mb-0">{{ row.abn }}</dd>
                        </dl>
                      </div>
                      <div class="col-lg-4 col-md-4 col-12">
                        <dl class="row">
                          <dt class="col-sm-5">Created date</dt>
                          <dd class="col-sm-7 mb-0">{{ row.created_at }}</dd>
                          <dt class="col-sm-5">Last updated date</dt>
                          <dd class="col-sm-7 mb-0">{{ row.updated_at }}</dd>
                          <dt class="col-sm-5">Created by</dt>
                          <dd class="col-sm-7 mb-0">{{ row.created_by }}</dd>
                          <dt class="col-sm-5">Updated by</dt>
                          <dd class="col-sm-7 mb-0">{{ row.edited_by }}</dd>
                        </dl>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>

              <!-- Pagination -->
              <tr>
                <td colspan="14">
                  <div class="sits-pagination-row">
                    <div class="items-per-page">
                      <div class="pr-2">
                        <p class="mb-0">Items per page</p>
                      </div>
                      <div class="pr-5">
                        <select
                          v-model="recordsPerPage"
                          class="form-control sits_select"
                          @change="fnRecordsPerPage()"
                        >
                          <option value="10">10</option>
                          <option value="15">15</option>
                          <option value="20">20</option>
                          <option value="30">30</option>
                          <option value="40">40</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                    </div>

                    <div>
                      <pagination
                        :limit="5"
                        :data="getReferralPartnerPaginateData"
                        @pagination-change-page="fnGetQuoteList"
                      ></pagination>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pagination from 'laravel-vue-pagination'
import { mapGetters, mapActions } from 'vuex'
import appModalReferralPartnerNew from '../../../components/settings/ModalReferralPartnerNew.vue'
import appModalReferralPartnerEdit from '../../../components/settings/ModalReferralPartnerEdit.vue'
import appModalQuoteStatusUpdate from '../../../components/admin/ModalQuoteStatusUpdate.vue'
import * as taxTableService from '../../../services/taxTable.service'
import appModalDocumentsUpload from '../../../components/quote/ModalDocumentsUpload.vue'
import appModalMsgDealer from '../../../components/quote/ModalMsgDealer.vue'
import appModalMsgVSA from '../../../components/quote/ModalMsgVSA.vue'

export default {
  name: 'adminQuoteList',
  components: {
    pagination,
    appModalReferralPartnerNew,
    appModalReferralPartnerEdit,

    appModalQuoteStatusUpdate,
    appModalDocumentsUpload,
    appModalMsgDealer,
    appModalMsgVSA
  },
  data() {
    return {
      isDataFetch: true,
      opened: [],
      quoteList: {},
      recordsPerPage: 15,
      page: 1,
      q: '',
      selectedStatus: '',
      sort_direction: 'asc',
      sort_field: 'id',
      quoteCalculation: {},
      paginate: {
        dealerUserId: '',
        page: 1,
        recordsPerPage: 15,
        q: '',
        selectedStatus: '',
        sort_direction: 'asc',
        sort_field: 'id'
      }
    }
  },
  computed: {
    ...mapGetters([
      'getReferralPartnerPaginateData',
      'getReferralPartnerPaginate'
    ])
  },
  methods: {
    ...mapActions(['fetchReferralPartnerPaginate']),
    toggle(id) {
      const index = this.opened.indexOf(id)
      if (index > -1) {
        this.opened.splice(index, 1)
      } else {
        this.opened.push(id)
      }
    },

    fnGetQuoteList: async function (page = 1) {
      let obj1 = this.paginate
      let obj2 = {
        page: page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchReferralPartnerPaginate(objNew)
    },

    fnRecordsPerPage() {
      let obj1 = this.paginate
      let obj2 = {
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }

      this.fetchReferralPartnerPaginate(objNew)
    },

    fnSearch() {
      let obj1 = this.paginate
      let obj2 = {
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchReferralPartnerPaginate(objNew)
    },

    fnChangeSort(field) {
      if (this.sort_field == field) {
        this.sort_direction = this.sort_direction == 'asc' ? 'desc' : 'asc'
      } else {
        this.sort_field = field
      }
      let obj1 = this.paginate
      let obj2 = {
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchReferralPartnerPaginate(objNew)
    },

    fnClear() {
      this.q = ''
      this.selectedStatus = ''
      let obj1 = this.paginate
      let obj2 = {
        page: 1,
        recordsPerPage: 15,
        q: '',
        selectedStatus: '',
        sort_direction: 'asc',
        sort_field: 'sortOrder'
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchReferralPartnerPaginate(objNew)
    }
  },
  created() {
    // Store taxTable information in local storage
    taxTableService.storeTaxTable()
  },

  async mounted() {
    this.isDataFetch = true
    let obj1 = this.paginate
    let obj2 = {
      page: 1,
      recordsPerPage: 15,
      q: '',
      selectedStatus: '',
      sort_direction: 'asc',
      sort_field: 'sortOrder'
    }
    let objNew = { ...obj1, ...obj2 }
    await this.fetchReferralPartnerPaginate(objNew)
    this.isDataFetch = false
  }
}
</script>

<style lang="scss" scoped>
.search-row {
  display: flex;
  // justify-content: space-between;
  gap: 20px;
  .search-box {
    width: 450px;
  }
  .status-box {
    width: 250px;
  }

  .item {
    align-self: center;
  }
}

.sits-pagination-row {
  display: flex;
  gap: 10px;
  align-items: baseline;
  padding-top: 5px;
  padding-bottom: 5px;

  .items-per-page {
    display: flex;
    align-items: baseline;
  }

  ul.pagination {
    margin-bottom: 0;
  }

  .page-item.active .page-link {
    z-index: 3;
    color: #fff;
    background-color: red;
    border-color: red;
  }
}
</style>
